import { StatusOption } from 'utils/__interfaces/Billings/BillEntity'

// TODO translation
export const statusOptions: StatusOption[] = [
  {
    value: 'all',
    label: 'Statuts de paiement',
    apiValue: '',
  },
  {
    value: 'notPaid',
    label: 'En attente*',
    apiValue: 'En attente',
  },
  {
    value: 'closed',
    label: 'Partiel*',
    apiValue: 'Partiel',
  },
  {
    value: 'paid',
    label: 'Complet*',
    apiValue: 'Complet',
  },
]

export const downloadErrorType = ['unavailable', 'technical']
